import {ready} from "../utils/ready.mjs";

;(function () {
    'use strict';

    // init main navigation
    ready(function () {
        const menus = document.querySelectorAll('.js-groupmenu-holder');
        if (menus.length > 0) {
            Array.prototype.forEach.call(menus, function (menu) {
                const m = new GroupMenu(menu);
            });
        }
    });

    // Constructor
    function GroupMenu(menu)
    {
        const self = this;
        self.menu = menu;

        const sections = self.menu.querySelectorAll('section[id]');
        const config = {
            rootMargin: '-50% 0px'
        };

        let observer = new IntersectionObserver(function (entries, self) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    intersectionHandler(entry);
                }
            });
        }, config);

        sections.forEach(section => {
            observer.observe(section);
        });

        function intersectionHandler(entry)
        {
            const id = entry.target.id;
            const currentlyActive = entry.target.closest('.js-groupmenu-holder').querySelector('.js-groupmenu-item.active');
            const shouldBeActive = entry.target.closest('.js-groupmenu-holder').querySelector('.js-groupmenu-item[href$="#' + id + '"]');

            // only remove old state oif there is a new one to set
            if (shouldBeActive && currentlyActive) {
                currentlyActive.classList.remove('active');
            }
            if (shouldBeActive) {
                shouldBeActive.classList.add('active');
            }
        }
    }

    // Export GroupMenu
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = GroupMenu;
    } else if (typeof define === 'function' && define.amd) {
        define('GroupMenu', [], function () {
            return GroupMenu;
        })
    } else {
        // attach to window
        window.GroupMenu = GroupMenu;
    }
}());
